// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.78.2/styles/" + (chunkId === 653 ? "videojs" : chunkId) + ".chunk.css?" + {"598":"e48a3919bacf5bb72238","653":"ed916f1c750f03117f60"}[chunkId] + "";
};